import { reactive } from "vue";
import axios from "axios";
import debounce from "lodash/debounce";
import { setWishList, clearWishList } from "@/mindbox";

const favouritesStore = {
  state: reactive({
    favourites: localStorage.getItem("favourites")
      ? JSON.parse(localStorage.getItem("favourites"))
      : [],
  }),
  toggleFavourites(id) {
    const index = this.state.favourites.indexOf(id);
    if (index !== -1) {
      this.state.favourites.splice(index, 1);
    } else {
      this.state.favourites.push(id);
    }
    const parsed = JSON.stringify(this.state.favourites);
    localStorage.setItem("favourites", parsed);
    this.syncWishList();
  },
  syncWishList: debounce(async function () {
    const ids = this.state.favourites;

    if (!ids.length) {
      clearWishList();
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API}building-objects/20/properties`
      );
      const flats = (response.data?.data || []).filter((flat) =>
        ids.includes(flat.id)
      );

      if (!flats.length) {
        clearWishList();
        return;
      }

      setWishList(
        flats.map((flat) => ({
          uuid: flat.uuid,
          price: flat?.properties?.new_cost || flat?.discount_cost || flat?.cost,
        }))
      );
    } catch (error) {
      console.error("[mindbox ERROR] favourites sync", error);
    }
  }, 300),
};

export default favouritesStore;
